import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { TextBadgeStyle } from './TextBadge.styles.js';

const defaultProps = {
    color: 'primary',
    fixed: false,
    rounding: 'sharp',
    sizing: 'medium',
    variant: 'filled',
};
const _TextBadge = forwardRef(({ children, className, color, fixed, sizing, variant, ...rest }, ref) => {
    if (variant === 'filled' &&
        color &&
        !['primary', 'neutral'].includes(color)) {
        console.error("SDS TextBadge: When the 'variant' prop is set to 'filled', the 'color' should be either 'primary' or 'neutral'.");
    }
    return (React.createElement("span", { className: className, ref: ref, ...rest }, children));
});
_TextBadge.displayName = '_TextBadge';
const TextBadge = styled(_TextBadge) `
    ${TextBadgeStyle}
`;
TextBadge.defaultProps = defaultProps;

export { TextBadge, _TextBadge, defaultProps };
//# sourceMappingURL=TextBadge.js.map
